import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/me_example.jpg'


const _hoisted_1 = { class: "timi-profile-container" }
const _hoisted_2 = { class: "timi-profile-content" }
const _hoisted_3 = { class: "profle-user-box" }
const _hoisted_4 = { class: "profile-image-rd" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Infos", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Firma", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Überstunden", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "--", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Urlaubstage", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "--", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Stundenlisten", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ListItem = _resolveComponent("ListItem")!
  const _component_List = _resolveComponent("List")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            false
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString(_ctx.employeeInitials), 1)
          ]),
          _createVNode(_component_IconButton, {
            icon: _ctx.store.getters.svgIcons.camera,
            raised: true,
            primary: true
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.sessionEmployee.firstName) + " " + _toDisplayString(_ctx.sessionEmployee.lastName), 1),
          _createVNode(_component_Button, {
            text: _ctx.$t('button.logout'),
            dense: true
          }, null, 8, ["text"])
        ])
      ]),
      _hoisted_6,
      _createVNode(_component_List, { raised: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ListItem, null, {
            default: _withCtx(() => [
              _hoisted_7,
              _createElementVNode("p", null, _toDisplayString(_ctx.sessionCompany.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ListItem, null, {
            default: _withCtx(() => [
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_ListItem, null, {
            default: _withCtx(() => [
              _hoisted_10,
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_ListItem, { class: "interactive" }, {
            default: _withCtx(() => [
              _hoisted_12,
              _createVNode(_component_IconButton, {
                icon: _ctx.store.getters.svgIcons.arrowforward,
                onOnClick: _ctx.handleShowTimetables
              }, null, 8, ["icon", "onOnClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}